import { PRODUCT_TOUR_STORAGE_KEYS } from "./product-tour-storage";

/**
 * The home page's "Pick up where you left off" trail: the project pages each person last had open, per
 * brand. Kept through a session expiring so signing back in doesn't reset it; signing out clears it.
 */
export const PROJECT_VISITS_STORAGE_KEY = "adora:project-visits";

/** Local storage keys that survive an authentication logout; everything else is cleared. */
export const LOGOUT_PRESERVED_STORAGE_KEYS = [...PRODUCT_TOUR_STORAGE_KEYS, PROJECT_VISITS_STORAGE_KEY] as const;
